import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable({
    providedIn: 'root',
})
export class ManagementHttpService {
    constructor(private configurations: ConfigurationService, private http: HttpClient) {}

    updateProductAvailability(branchId: any, productId: any, state: string): Observable<any> {
        return this.http.put<any>(
            `${this.configurations.baseUrl}/api/management/updateProductAvailability`,
            {},
            { params: { branchId: branchId, productId: productId, state: state } }
        );
    }

    getProductAvailabilityState(branchId: any): Observable<any> {
        return this.http.get<any>(`${this.configurations.baseUrl}/api/management/getProductAvailabilityState`, { params: { branchId: branchId } });
    }
}
